/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { FC, useState, useEffect } from 'react';
import { Interval as Range } from 'date-fns';
import isDate from 'lodash/isDate';
import './personal-account-operations-modal.scss';
import '../personal-account.scss';
import { useAppSelector, useEnhancedTranslation, useMedia } from '@app/hooks';
import FormCalendarRange from '@app/components/inputs/FormCalendarRange';
import {
  getCardOperationsList,
  getCurrentCardOperationsList,
  TCardOperationDateItem,
  TGiftCardsActiveCard,
  TGiftCardsArchiveCard,
} from '@app/api/giftCards/gift-cards.service';
import { formatDate, formatDateV2, formatNumberWithSpaces } from '@app/utils';
import {
  CardsOrderTab,
  CardsOrderTabsWrap,
} from '@app/pages/cards/components/CardsOrderModal/components/CardsOrderTabs/CardsOrderTabs';
import { mapOperationsData, TRecentOperationDate } from '../helpers';

type TProps = {
  onClose: () => void;
  activeCardData: TGiftCardsActiveCard[];
  archiveCardData: TGiftCardsArchiveCard[];
};

const PersonalAccountOperationsModal: FC<TProps> = ({ onClose, activeCardData, archiveCardData }) => {
  const { t } = useEnhancedTranslation({ keyPrefix: 'account.personalAccount.operationsModal' });
  const { isMobile } = useMedia();
  const [choosedDate, setChoosedDate] = useState<Date | Range | null>(null);
  const [recentOperations, setRecentOperations] = useState<TCardOperationDateItem[]>([]);
  const [currentLang, setCurrentLang] = useState('ru');
  const [mappedOperations, setMappedOperations] = useState<TRecentOperationDate[]>([]);
  const [activeStep, setActiveStep] = useState<'list' | 'cards'>('list');
  const [activeCardType, setActiveCardType] = useState<'valid' | 'archive'>('valid');
  const [choosedCard, setChoosedCard] = useState<{ num: string; name: string } | null>(null);

  function chooseCard(num: string, name: string): void {
    setChoosedCard({ num, name });
    setActiveCardType('valid');
    setActiveStep('list');
  }

  const {
    authReducer: {
      access: { accessToken },
    },
  } = useAppSelector((state) => state);

  async function getOperationsData(token: string, cardNumber?: string | null): Promise<void> {
    try {
      let startDate = formatDateV2(new Date());
      if (choosedDate && isDate(choosedDate)) {
        startDate = formatDateV2(choosedDate);
      } else if (choosedDate) {
        startDate = formatDateV2(choosedDate.start as Date);
      }
      let endDate = formatDateV2(new Date());
      if (choosedDate && isDate(choosedDate)) {
        endDate = formatDateV2(choosedDate);
      } else if (choosedDate) {
        endDate = formatDateV2(choosedDate.end as Date);
      }
      if (cardNumber) {
        const res = await getCurrentCardOperationsList(cardNumber, startDate, endDate, token);
        setRecentOperations(res);
      } else {
        const res = await getCardOperationsList(startDate, endDate, token);
        setRecentOperations(res);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getOperationsData(accessToken || '', choosedCard?.num);
  }, [accessToken, choosedDate, choosedCard]);

  useEffect(() => {
    const lang = localStorage.getItem('lang');
    if (lang === 'ru' || lang === 'en') {
      setCurrentLang(lang);
    }
  }, []);

  useEffect(() => {
    setMappedOperations(mapOperationsData(recentOperations, currentLang));
  }, [recentOperations, currentLang]);

  console.log(choosedCard);

  return (
    <div className="personal-account-operations-modal">
      <div
        className={`personal-account-operations-modal-operations ${
          activeStep === 'list' ? 'personal-account-operations-modal-operations--visible' : ''
        }`}
      >
        <div className="personal-account-operations-modal-operations__title-wrap">
          <div className="personal-account-operations-modal-operations__title">{t('operationsTitle')}</div>
          <button
            type="button"
            title="Close button"
            className="personal-account-operations-modal-operations__close"
            onClick={onClose}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
              <rect
                x="29.0625"
                y="30.3999"
                width="30.3463"
                height="1.89664"
                transform="rotate(-135 29.0625 30.3999)"
                fill="#1F1F1F"
              />
              <rect
                x="7.60156"
                y="29.0586"
                width="30.3463"
                height="1.89664"
                transform="rotate(-45 7.60156 29.0586)"
                fill="#1F1F1F"
              />
            </svg>
          </button>
        </div>
        <div className="personal-account-operations-modal-operations__input-wrap">
          <FormCalendarRange
            value={choosedDate}
            setValue={setChoosedDate}
            isMobile={isMobile}
            placeholder={t('date.placeholder') || ''}
            minDate={new Date('2025-01-01')}
          />
          <button
            className="personal-account-operations-modal-operations__card-btn"
            type="button"
            onClick={() => setActiveStep('cards')}
          >
            {choosedCard ? (
              <span>{choosedCard.name}</span>
            ) : (
              <span className="personal-account-operations-modal-operations__card-btn-placeholder">
                {t('cardSelect.placeholder')}
              </span>
            )}
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 16.0947L21 7.09474L20.9053 7C20.9053 7 15.9553 11.9263 12 11.9263C8.04474 11.9263 3.09473 7 3.09473 7L3 7.09474L12 16.0947Z"
                fill="#1F1F1F"
              />
            </svg>
          </button>
        </div>
        <div className="personal-account-operations-modal-operations__list-wrap">
          {mappedOperations?.map((item) => {
            return (
              <div className="personal-account__operations-list-block" key={`${item.date}-block-modal`}>
                <div className="personal-account__operations-list-block-title">{item.date}</div>
                {item.items.map((operation, opIndex) => {
                  return (
                    <div className="personal-account__operation" key={`${`${operation.type}-${opIndex}`}key-modal`}>
                      <div className="personal-account__operation-info-wrap">
                        <div className="personal-account__operation-img">
                          {operation?.image ? (
                            <img src={`${process.env.REACT_APP_IMAGES_URL}${operation.image}`} alt="" />
                          ) : (
                            <img src="/img/shop_plug.png" alt="" />
                          )}
                        </div>
                        <div className="personal-account__operation-info-block">
                          <div className="personal-account__operation-info-title">{operation.cardName}</div>
                          <div className="personal-account__operation-info-name">{t(`${operation.caption}`)}</div>
                        </div>
                      </div>
                      {operation.value && operation.type !== 'return' && operation.type !== 'refund' && (
                        <div className="personal-account__operation-cost">
                          {operation.type === 'activation' ? '+' : '-'} {formatNumberWithSpaces(operation.value)} ₽
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
      <div
        className={`personal-account-operations-modal-cards ${
          activeStep === 'cards' ? 'personal-account-operations-modal-cards--visible' : ''
        }`}
      >
        <div className="personal-account-operations-modal-cards__title-wrap">
          <div className="personal-account-operations-modal-cards__title">{t('cardsTitle')}</div>
          <button
            type="button"
            title="Close button"
            className="personal-account-operations-modal-cards__close"
            onClick={onClose}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
              <rect
                x="29.0625"
                y="30.3999"
                width="30.3463"
                height="1.89664"
                transform="rotate(-135 29.0625 30.3999)"
                fill="#1F1F1F"
              />
              <rect
                x="7.60156"
                y="29.0586"
                width="30.3463"
                height="1.89664"
                transform="rotate(-45 7.60156 29.0586)"
                fill="#1F1F1F"
              />
            </svg>
          </button>
        </div>
        <div className="personal-account-operations-modal-cards__tabs-wrap">
          <CardsOrderTabsWrap>
            <CardsOrderTab
              type="left"
              active={activeCardType === 'valid'}
              title={t('validCards')}
              onClick={() => setActiveCardType('valid')}
            />
            <CardsOrderTab
              type="right"
              active={activeCardType === 'archive'}
              title={t('archiveCards')}
              onClick={() => setActiveCardType('archive')}
            />
          </CardsOrderTabsWrap>
        </div>
        <div className="personal-account-operations-modal-cards__list">
          {activeCardType === 'valid' &&
            activeCardData.map((item) => (
              <div
                key={item.cardId}
                className="personal-account-operations-modal-cards__list-item"
                onClick={() => chooseCard(item.cardNumber || '', item.product.name[currentLang as 'ru' | 'en'])}
              >
                <div className="personal-account-operations-modal-cards__list-item-image">
                  <img src={`${process.env.REACT_APP_IMAGES_URL}${item.product.imageUrl}`} alt="" />
                </div>
                <div className="personal-account-operations-modal-cards__list-item-wrap">
                  <div className="personal-account-operations-modal-cards__list-item-title-wrap">
                    <div className="personal-account-operations-modal-cards__list-item-title">
                      {item.product.name[currentLang as 'ru' | 'en']}
                    </div>
                    <div className="personal-account-operations-modal-cards__list-item-expired">
                      {t('before')} {formatDate(new Date(item.expireDate))}
                    </div>
                  </div>
                  <div className="personal-account-operations-modal-cards__list-item-sum">
                    {formatNumberWithSpaces(item.availAmnt.toString())} ₽{' '}
                    <span>
                      {t('of')} {formatNumberWithSpaces(item.nominal.toString())} ₽
                    </span>
                  </div>
                </div>
              </div>
            ))}
          {activeCardType === 'archive' &&
            archiveCardData.map((item) => (
              <div
                key={item.cardId}
                className="personal-account-operations-modal-cards__list-item"
                onClick={() => chooseCard(item.cardNumber || '', item.product.name[currentLang as 'ru' | 'en'])}
              >
                <div className="personal-account-operations-modal-cards__list-item-image">
                  <img src={`${process.env.REACT_APP_IMAGES_URL}${item.product.imageUrl}`} alt="" />
                </div>
                <div className="personal-account-operations-modal-cards__list-item-wrap">
                  <div className="personal-account-operations-modal-cards__list-item-title-wrap">
                    <div className="personal-account-operations-modal-cards__list-item-title">
                      {item.product.name[currentLang as 'ru' | 'en']}
                    </div>
                  </div>
                  {item.availAmnt !== 0 ? (
                    <div className="personal-account-operations-modal-cards__list-item-caption">
                      {t('expired')} {formatDate(new Date(item.expireDate))}
                    </div>
                  ) : (
                    <div className="personal-account-operations-modal-cards__list-item-caption">
                      {t('exhausted')} {formatDate(new Date(item.expireDate))}
                    </div>
                  )}
                  <div className="personal-account-operations-modal-cards__list-item-caption">
                    {t('nominal')} {formatNumberWithSpaces(item.nominal.toString())} ₽
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default PersonalAccountOperationsModal;
